<template>
    <div>
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Cases</div>
            <!-- <div class="title">成功案例</div> -->
        </div>
        <div class="m-3">
            <div class="flex-row flex-wrap justify-between">
                <!-- <div @click="page(index)" class="cases-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                    v-for="(item, index) in 18" style="border: none;">
                    <img :src="require('../../assets/img/customers_logo/客户logo1-0' + (index + 1) + '.png')" alt=""> -->
                    <div @click="page(item.id)" class="cases-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                    v-for="(item, index) in customerData" style="border: none;">
                    <img :src="http.ipAddress+item.filePath"
                                 alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData, meterData } from "../products/products";
export default {
    data() {
        return {
            customerData:[]
        }
    },
    methods: {
        page(index) {
            this.$router.push({path:'/casesDetail', query: {index}});
        }
    },
    mounted() {
        debugger
        let that=this;
        this.http.post("/api/FJ_Customer/GetAllCustomer",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.customerData=objResult.data;
            }
        });
    }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/casesbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}

.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
}

.mt-3 {
    margin-top: 30px;
}


.cases-item {
    width: 48%;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #eee;
}

.cases-item img {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 150px;
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}
</style>


// WEBPACK FOOTER //
// src/views/cases/m_index.vue